import { render, staticRenderFns } from "./chatRooms.vue?vue&type=template&id=4345b66e&scoped=true&"
import script from "./chatRooms.vue?vue&type=script&lang=ts&"
export * from "./chatRooms.vue?vue&type=script&lang=ts&"
import style0 from "./chatRooms.vue?vue&type=style&index=0&id=4345b66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4345b66e",
  null
  
)

export default component.exports